import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import classNames from 'classnames'
import {GlobalOutlined} from '@ant-design/icons'
import {SUPPORTED_LANGS} from '@/constants/lang'
import {Popover} from '@/components'
import {THasClassName} from '@/types/common/THasClassName'

import styles from './styles.scss'
import {EARTH_ICON, LANGUAGE} from '@/constants/playwright-ids'
import {getUserLanguage, setUserLanguage} from '@/services/lang'

type LanguageSelectProps = THasClassName

export const LanguageSelect = ({className}: LanguageSelectProps) => {
    const {t: tEnums} = useTranslation('enums')
    const [open, setOpen] = useState<boolean>(false)
    const selectedLanguage = getUserLanguage()

    const onClick = (value: string) => {
        setUserLanguage(value)
        location.reload()
    }

    const content = () => {
        return (
            <div className={styles.content}>
                {SUPPORTED_LANGS.map((lang) => {
                    return (
                        <div
                            key={lang}
                            className={classNames(styles.row, {
                                [styles.active]: selectedLanguage === lang
                            })}
                            onClick={() => onClick(lang)}
                            data-test-id={LANGUAGE + '_' + lang}
                        >
                            {tEnums('languages.' + lang)}
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <Popover
            open={open}
            overlayClassName={styles.overlay}
            placement={'bottomRight'}
            content={content()}
            trigger={'click'}
            onOpenChange={setOpen}
        >
            <div className={classNames(styles.iconHolder, className)} data-test-id={EARTH_ICON}>
                <GlobalOutlined className={styles.icon} />
            </div>
        </Popover>
    )
}
